<p-dialog
  [(visible)]="displayTaskDetailModal"
  (onHide)="closeTaskDetailModal()"
  class="summary-popup"
  [style]="{
    width: '70%',
    height: '90%',
    maxHeight: '100%',
    overflow: 'hidden',
  }"
  appendTo="body">
  <ng-template pTemplate="header" class="pt-2">
    <div
      *ngIf="(isRedirected && isAuthorized) || !isRedirected"
      class="has-border col-lg d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-2">
        <h2 class="m-0 p-0 d-flex align-items-center">
          {{ taskDetail.taskPaddedId }}
          <span>- {{ taskDetail.title }}</span>
        </h2>
        <div class="lds-ring inline ms-2" *ngIf="showSmallLoader">
          <jni-spinner></jni-spinner>
        </div>
      </div>

      <div class="col-auto d-flex gap-4 align-items-center">
        <div *ngIf="isSalesTask" class="col-auto">
          <a
            href="javascript:;"
            [ngClass]="{ disabled: showSmallLoader }"
            class="link-primary text-decoration-none d-flex align-items-center gap-1"
            (click)="copyTaskFn()">
            <span>Copy Task</span>
          </a>
        </div>
        <div class="col-auto d-flex align-items-center gap-2">
          <label class="text-bold" [ngStyle]="{ 'font-size': '0.85rem' }"
            >Notifications</label
          >
          <p-toggleSwitch
            [(ngModel)]="notificationSwitch"
            (onChange)="switchNotification($event)"></p-toggleSwitch>
        </div>
        <div *ngIf="workflowId" class="col-auto">
          <a
            href="javascript:;"
            class="text-decoration-none d-flex align-items-center gap-1"
            (click)="displayChatDialog()">
            <span>Chat</span>
          </a>
        </div>
        <div class="col-auto">
          <a
            href="javascript:;"
            (click)="updateFollow()"
            class="text-decoration-none d-flex align-items-center gap-1">
            <span>{{ taskDetail?.isFollow ? "Unfollow" : "Follow" }}</span>
          </a>
        </div>
      </div>
    </div>
  </ng-template>

  <div
    class="col-lg-12 field-style"
    *ngIf="(isRedirected && isAuthorized) || !isRedirected">
    <div class="row">
      <div
        class="cal-pop-task"
        [class.col-lg-8]="!isSummaryView"
        [class.col-lg-9]="isSummaryView">
        <div class="gray-bg-rounded">
          <div
            [formGroup]="descriptionForm"
            class="col-lg-12 des-hgt editor-box">
            <p-editor
              formControlName="description"
              ngDefaultControl
              #contentEditor
              id="content-editor"
              [style]="{ height: '170px' }"></p-editor>
          </div>
          <div class="col-lg-12 mb-2 d-flex justify-content-end">
            <!-- <button
          pButton
          type="button"
          label="Save Description"
          class="p-button-sm"
          (click)="saveDescription()"></button> -->

            <p-button label="Save Description" (click)="saveDescription()" />
          </div>
        </div>
        <div class="gray-bg-rounded mt-2">
          <div class="col-lg-12">
            <div class="globalborder-btm-header pt-2 pb-2 mb-3">
              <h2 class="mb-0 pb-0">Comments</h2>
            </div>
          </div>
          <div class="scroll-commit">
            <div class="comment-box mb-4" *ngFor="let comment of commentList">
              <span class="comment-name">{{ comment.createdBy }}</span>
              <div class="comment-section">
                <span class="name-circle">{{
                  getAcronym(comment.createdBy)
                }}</span>
                <p
                  [innerHtml]="formatMessage(comment.comment)"
                  class="comment-message"></p>
              </div>
              <div class="comment-date-time">
                {{ comment.createdDate | date: "hh:mm:ss a MMMM dd, y" }}
              </div>
            </div>
          </div>
        </div>
        <div class="gray-bg-rounded mt-2">
          <p-select
            #tagDropdown
            [(ngModel)]="selectedTagId"
            [options]="ownerList"
            optionLabel="name"
            (onChange)="onTagSelectionChange(selectedTagId)"
            *ngIf="showTagDropdown"
            notFoundText="No User Found"
            optionValue="userId"
            [filter]="true"
            [showClear]="true">
          </p-select>
          <textarea
            pInputText
            pInputTextarea
            [(ngModel)]="comment"
            (keydown)="inputHandler($event)"></textarea>
          <div class="d-flex align-items-center justify-content-end">
            <!-- <button
            pButton
            type="button"
            label="Comment"
            class="p-button-sm"
            (click)="sendMessage()"></button> -->

            <p-button label="Comment" (click)="sendMessage()" />
          </div>
        </div>
      </div>
      <div class="col-lg-4 summary-right">
        <div class="gray-bg-rounded">
          <div class="row">
            <div class="d-flex mb-1 d-flex gap-2 align-items-end">
              <div class="col-lg-11 d-flex gap-3 align-items-end">
                <form class="col-lg-7">
                  <div class="form-group has-float-label">
                    <label class="form-label">Status</label>
                    <p-select
                      (onChange)="updateTaskStatus()"
                      [(ngModel)]="selectedTaskStatus"
                      [ngModelOptions]="{ standalone: true }"
                      [showClear]="false"
                      [filter]="true"
                      optionLabel="name"
                      optionValue="name"
                      [options]="taskStatusList">
                    </p-select>
                  </div>
                </form>

                <p-tag
                  *ngIf="taskDetail?.priorityType !== null"
                  value="{{
                    getPriorityByTitle(taskDetail.priorityType)
                  }}"></p-tag>
              </div>
              <div class="col-lg-1">
                <a (click)="clickEdit()" class="edit-icon">
                  <i class="pi pi-pencil"></i>
                </a>
              </div>
            </div>
            <div class="d-flex d-flex gap-1 align-items-center mb-2 mt-2">
              <h3 class="m-0">Client</h3>
              <p class="m-0">{{ taskDetail.clientName ?? "N/A" }}</p>
            </div>

            <div class="d-flex d-flex gap-1 align-items-center mb-2">
              <h3 class="m-0">Due Date</h3>
              <p class="m-0">{{ taskDetail.dueDate | date: "MMM d, y" }}</p>
            </div>

            <div class="col-lg-12">
              <h3 class="mb-2">Assigned To</h3>
              <div class="d-flex gap-1 mt-1 align-items-center">
                <div
                  class="assign-name-box rounded-circle p-3"
                  *ngIf="taskDetail?.assignedTo !== ''">
                  {{ getAcronym(taskDetail.assignedTo) }}
                </div>
                <p class="mb-0" *ngIf="taskDetail?.assignedTo === ''">N/A</p>
                <div>
                  <p class="mb-0">{{ taskDetail.assignedTo }}</p>
                  <p class="mb-0">{{ taskDetail.assignUserType }}</p>
                </div>
              </div>
            </div>

            <div
              class="col-lg-12 d-flex gap-2 align-items-center mb-2 mt-2 tag-col">
              <div
                class="col-auto d-flex gap-1 align-items-center tag-bx"
                [style.color]="i?.tagColor"
                *ngFor="let i of taskDetail.tags; index as num">
                <i class="pi pi-tag"></i>
                <span>{{ i?.tagTitle }}</span>
                <i
                  class="pi pi-times"
                  style="cursor: pointer"
                  (click)="tagDelConfirmation(i.tagId, num, i.tagTitle)"></i>
              </div>
            </div>

            <div class="col-lg-12 mt-2" style="cursor: pointer">
              <h3 class="mb-1">Linked Project</h3>
              <div class="d-flex gap-1">
                <p-tag
                  value="Project - {{ taskDetail.projectPaddedId }}"
                  *ngIf="taskDetail.projectPaddedId !== ''"
                  class="tag-skycol"
                  (click)="redirectToWorkflowSummary()">
                  <i class="pi pi-link"></i>
                </p-tag>
              </div>
              <div
                class="d-flex gap-1"
                *ngIf="taskDetail.projectPaddedId === ''">
                <p>No Project found</p>
              </div>
            </div>

            <div class="col-lg-12 mt-2" style="cursor: pointer">
              <h3 class="mb-1">Linked Order</h3>
              <div class="d-flex gap-1">
                <p-tag
                  value="Order - {{ taskDetail.salesOrderId }}"
                  class="tag-skycol"
                  (click)="showOrderModal()"
                  *ngIf="taskDetail.salesOrderId !== ''">
                  <i class="pi pi-link"></i>
                </p-tag>
              </div>
              <div class="d-flex gap-1" *ngIf="taskDetail.salesOrderId === ''">
                <p>No Linked Order found</p>
              </div>
            </div>

            <div class="col-lg-12 mt-2">
              <h3 class="mb-1">Job Name</h3>
              <div class="d-flex gap-1">
                <p-tag
                  value="{{ taskDetail.jobName }}"
                  *ngIf="taskDetail.jobName !== ''"
                  class="tag-skycol"></p-tag>
              </div>
              <div class="d-flex gap-1" *ngIf="taskDetail.jobName === ''">
                <p>No Job Name found</p>
              </div>
            </div>

            <div class="col-lg-12 mt-2">
              <h3 class="mb-1">Attachments</h3>
              <div
                class="d-flex gap-1"
                *ngFor="let document of taskDetail?.documents; index as i">
                <p-tag
                  value="{{ document.name }}"
                  class="pdf-tag"
                  (click)="downloadFile(document.url)">
                  <i
                    class="pi pi-times"
                    (click)="
                      attachmentDelConfirmation(document, i);
                      $event.stopPropagation()
                    "></i>
                </p-tag>
              </div>
              <div
                class="d-flex gap-1"
                *ngIf="taskDetail?.documents?.length === 0">
                <p class="mb-0">No Attachment found</p>
              </div>
            </div>
            <div class="col-lg-12 mt-2">
              <div
                class="d-flex justify-content-between align-items-center mb-1">
                <h3 class="mb-0">Owner</h3>
              </div>
              <h2 class="m-0" *ngIf="taskDetail.owner !== ''">
                {{ taskDetail?.owner }}
              </h2>
              <div class="d-flex gap-1" *ngIf="taskDetail.owner === ''">
                <p>No Owner found</p>
              </div>
            </div>
            <div class="col-lg-12 mt-2">
              <div
                class="d-flex justify-content-between align-items-center mb-1">
                <h3 class="mb-0">Created By</h3>
              </div>
              <p>{{ taskDetail.createdBy }}</p>
            </div>
            <div class="col-lg-12 mt-2">
              <div
                class="d-flex justify-content-between align-items-center mb-1 onhover-hght">
                <h3 class="mb-0">Created Date</h3>
                <span>
                  <a>
                    <i
                      class="pi pi-clock"
                      (mouseenter)="taskLogsPopover.toggle($event)"></i>
                  </a>
                </span>
              </div>
              <p>
                {{ taskDetail.createdDate | date: "MMM d, y" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-popover
  #taskLogsPopover
  (onHide)="taskLogsPopover.hide()"
  class="task-logs-popover">
  <div
    class="task-logs-container"
    *ngIf="taskLogs.length > 0"
    #scrollContainer
    (scroll)="onScrollContainer($event)"
    [class.has-scroll-top]="showScrollTop"
    [class.has-scroll-bottom]="showScrollBottom">
    <div class="scroll-indicator-top" *ngIf="showScrollTop">
      <i class="pi pi-chevron-up"></i>
      <span>Scroll up for more</span>
    </div>
    <div class="task-log-item" *ngFor="let log of taskLogs; let last = last">
      <div class="log-content">
        <h4 class="log-message" [innerHtml]="log.log"></h4>
        <div class="log-meta">
          <span class="log-datetime">
            <i class="pi pi-calendar"></i>
            {{ log.createdDate | date: "hh:mm:ss a MMM d, y" }}
          </span>
          <span class="log-author">
            <i class="pi pi-user"></i>
            {{ log.createdBy }}
          </span>
        </div>
      </div>
      <p-divider *ngIf="!last"></p-divider>
    </div>
    <div class="scroll-indicator-bottom" *ngIf="showScrollBottom">
      <i class="pi pi-chevron-down"></i>
      <span>Scroll down for more</span>
    </div>
  </div>
  <div class="task-logs-empty" *ngIf="taskLogs.length === 0">
    <div class="empty-state">
      <i class="pi pi-info-circle"></i>
      <h4>No Activity</h4>
      <p>No activity recorded for this task yet</p>
    </div>
  </div>
</p-popover>

<p-dialog
  [style]="{ width: '80%', height: '95%', maxHeight: '100%' }"
  appendTo="body"
  [(visible)]="displayOrderSummary"
  (onHide)="closeOrderModal()">
  <div class="panelBody">
    <jni-order-summary
      *ngIf="salesOrderId !== '' && displayOrderSummary"
      [saleOrderIdFromModal]="salesOrderId"
      (closeOrderSummaryModalEvent)="closeOrderModal()">
    </jni-order-summary>
  </div>
</p-dialog>

<p-dialog
  header="Edit Task"
  [style]="{
    width: '80%',
    height: 'auto',
    overflow: 'hidden',
    maxHeight: 'fit-content',
  }"
  appendTo="body"
  [(visible)]="displayAddTaskModal"
  (onHide)="closeAddTask()"
  [draggable]="false">
  <ng-template #header>
    <div class="d-flex align-items-center gap-2">
      <h2 class="mb-0">Edit Task</h2>
      <div class="lds-ring inline me-auto ms-2" *ngIf="showAddTaskSmallLoader">
        <jni-spinner></jni-spinner>
      </div>
    </div>
  </ng-template>
  <jni-task-header
    *ngIf="displayAddTaskModal"
    [showTaskHeader]="showTaskModal"
    (closeAddTask)="closeAddTask()"
    [taskIdSelected]="taskIdSelected"
    (showAddNewProjectModal)="openAddNewProjectModal()"
    (showSmallLoaderEvent)="
      showOrHideAddTaskSmallLoader($event)
    "></jni-task-header>
</p-dialog>

<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>
<jni-chatbox
  #chatBox
  *ngIf="displayChat"
  [displayChat]="displayChat"
  (displayChange)="onHide()"
  [messageList]="messageList"
  (sendChatMessageEvent)="sendChatMessage($event)"
  [chatFirstCurrentDateIndex]="chatFirstCurrentDateIndex"
  [moduleName]="chatModuleName"
  [moduleId]="paddedWorkflowId"
  [users]="ownerList">
</jni-chatbox>
<p-dialog
  appendTo="body"
  header="New Project"
  [position]="'center'"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [style]="{
    width: '300px',
    height: '335px',
    'border-radius': '10px',
    overflow: 'visible',
  }"
  [(visible)]="showAddNewProjectModal"
  (onHide)="closeAddNewProjectModal()">
  <jni-create-project-on-task
    #createProjectOnTask
    (closeModal)="closeAddNewProjectModal()"
    (refreshProjectGrid)="refreshProjectGrid($event)">
  </jni-create-project-on-task>
</p-dialog>
